// @flow
import * as React from 'react';
import Stream from './components/Stream.jsx';
import GapItemFragment from './fragments/GapItemFragment.gql';
import StreamPlaceholder from './components/StreamPlaceholder.jsx';
import ChatStreamFragment from './fragments/ChatStreamFragment.gql';
import MessageItemFragment from './fragments/MessageItemFragment.gql';
import EntityStreamFragment from './fragments/EntityStreamFragment.gql';
import SequenceItemFragment from './fragments/SequenceItemFragment.gql';
import PhoneCallItemFragment from './fragments/PhoneCallItemFragment.gql';
import SystemMessageItemFragment from './fragments/SystemMessageItemFragment.gql';

export const CTX_CHAT_STREAM = 'CTX_CHAT_STREAM';
export const CTX_ANNOUNCEMENT_STREAM = 'CTX_ANNOUNCEMENT_STREAM';
export const StreamContext = React.createContext(CTX_ANNOUNCEMENT_STREAM);

export {
  Stream,
  GapItemFragment,
  StreamPlaceholder,
  ChatStreamFragment,
  MessageItemFragment,
  EntityStreamFragment,
  SequenceItemFragment,
  PhoneCallItemFragment,
  SystemMessageItemFragment,
};
